import * as React from 'react';
import { useAuth } from '../../../../App';
import { Modal, ModalBody, CustomDatePicker, ModalSize, ModalFooter, CustomButton, ButtonType, CustomSubmitButton, Form } from 'soprasteria-ui-library';
import { OrthodonticReferralAdministrationApi } from '../../../../api/OrthodonticReferralAdministrationApi';

interface IOrthodonticReferralExtendValidDateModal {
    orthodonticReferralId: number;
    renderForm: boolean;
    changeSuccessMessage: (message: string) => void;
    onFormClose: () => void;
    getOrthodonticReferral: (id: number) => void;
    decisionDate: Date;
}

interface ISaveExtendValidDate {
    extendedDate: Date;
}

export const OrthodonticReferralExtendValidDateModal: React.FunctionComponent<IOrthodonticReferralExtendValidDateModal> = ({ orthodonticReferralId, renderForm, changeSuccessMessage, onFormClose, getOrthodonticReferral, decisionDate }) => {
    const auth = useAuth();
    const api = new OrthodonticReferralAdministrationApi(auth);
    const [isExtending, setIsExtending] = React.useState<boolean>(false);

    const extendValidDate = (data: ISaveExtendValidDate) => {
        setIsExtending(true);

        api.extendValidDate(orthodonticReferralId, data.extendedDate, () => {
            changeSuccessMessage("Giltighetsdatumet har förlängts");
            document.getElementById("close-extend-valid-date-modal")?.click();
            getOrthodonticReferral(orthodonticReferralId);
        }, undefined, () => setIsExtending(false))
    }

    const closeForm = () => {
        onFormClose();
    }

    const getMaxDate = () => {
        var maxDate = new Date(decisionDate);
        maxDate.setFullYear(maxDate.getFullYear() + 1);
        return maxDate;
    }

    return (
        <>
            <Modal header="Förläng giltighetsdatum" id="extend-valid-date-modal" modalSize={ModalSize.normal}>
                {
                    renderForm ?
                        <Form onSubmit={extendValidDate}>
                            <ModalBody>
                                <CustomDatePicker name="extendedDate" label="Förläng till" min={new Date(decisionDate)} max={getMaxDate()} inlineLabel required />
                            </ModalBody>
                            <ModalFooter>
                                <CustomButton buttonType={ButtonType.general} buttonText="Avbryt"
                                    data-dismiss="modal" id="close-extend-valid-date-modal" onClick={() => closeForm()} />
                                <CustomSubmitButton isLoading={isExtending}>Spara</CustomSubmitButton>
                            </ModalFooter>
                        </Form>
                        : null
                }
            </Modal>
        </>
    )
}